import styled from 'styled-components'

export const SectionWrap = styled.div`
  position: relative;
`
export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 450px 1fr;
  align-items: center;
  grid-gap: 110px;
  position: relative;
  z-index: 2;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    grid-gap: 40px;
  }
`
export const TextContent = styled.div`
  align-self: flex-start;

  @media (min-width: 1200px) {
    margin-top: 40px;
  }
`
export const Description = styled.p`
  font-weight: var(--font-regular);
  font-size: 18px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`
export const Feefo = styled.div`
  margin-top: 12px;

  p {
    font-weight: var(--font-bold);
  }

  & > span {
    margin-top: 12px;
    display: block;
    font-size: 12px;
    font-weight: var(--font-regular);
  }
`
export const Cards = styled.div`
  display: flex;
  grid-gap: 24px;
  justify-content: flex-start;

  @media (max-width: 1200px) {
    gap: 16px;
  }
`
export const CardColumnLeft = styled.div`
  margin-top: 80px;
  width: 50%;
  display: grid;
  gap: 25px;

  @media (max-width: 1200px) {
    gap: 16px;
    margin-top: 25px;
  }
`
export const CardColumnRight = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 25px;

  @media (max-width: 1200px) {
    gap: 16px;
  }
`
export const Card = styled.div<{ variant: 'yellow' | 'black' }>`
  border-radius: 20px;
  background: ${({ variant }) => (variant === 'yellow' ? 'var(--brand-primary)' : 'var(--brand-secondary)')};
  color: ${({ variant }) => (variant === 'yellow' ? 'var(--brand-secondary)' : 'white')};
  padding: 60px 40px;
  text-align: center;

  & h2 {
    text-align: center;
  }

  svg {
    margin-bottom: 20px;
    width: 50px;
    height: 50px;
  }

  @media (max-width: 1200px) {
    padding: 30px;

    svg {
      margin-bottom: 16px;
    }
  }
`
export const CardDescription = styled.p`
  font-size: 14px;
  font-weight: var(--font-regular);
  margin-top: 12px;
  line-height: 22px;
  text-align: center;

  @media (max-width: 600px) {
    display: none;
  }
`
